<template>
  <div class="flex-center-column home-mcn">
    <div class="title-zh">MCN机构</div>
    <div class="title-en">他们已入驻火乐园，也非常期待您的加入</div>
    <div class="flex-row-h-center mcn-list">
      <div class="flex-column-center mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
      <div class="flex-center-column mcn-item">
        <img src="@/assets/home/logo1.png" alt="">
        <span class="dec">铭瀚国际</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home-mcn"
}
</script>

<style lang="scss" scoped>
.home-mcn {
  width: 1200px;
  margin: 32px auto 0;
  padding: 32px 0;

  .title-zh {
    position: relative;
    color: #1d2129;
    font-size: 24px;
    line-height: 32px;
    z-index: 1;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 8px;
      background: url("~@/assets/home/title_decoration.png") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      z-index: -1;
    }
  }

  .title-en {
    color: #86909c;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin-top: 8px;
  }

  .mcn-list {
    flex-wrap: wrap;
    width: 1000px;
    margin-top: 24px;

    .mcn-item {
      width: 20%;
      padding: 24px;
      background: #fff;
      text-align: center;

      img {
        width: 80px;
        height: 80px;
      }

      .dec {
        color: #1d2129;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 12px;
      }
    }
  }
}
</style>